import { useId } from "react";

import { Tracker } from "@util/tracker";

import {
  StyledImage,
  StyledPlayIcon,
  StyledEyebrow,
  StyledText,
  StyledTimestamp,
} from "./components";
import { CardProps, CardWithTrackingProps } from "./types";

import styles from "./styles.module.css";

export function Component(props: CardProps) {
  const { playIcon, eyebrow, image, timestamp } = props;

  return (
    <article className={styles.cardContainer}>
      <div className={styles.leftColumn} data-skeleton-selector>
        {image && <StyledImage {...props} />}
        {playIcon && <StyledPlayIcon />}
      </div>
      <div className={styles.rightColumn} data-skeleton-selector>
        {eyebrow && <StyledEyebrow {...props} />}
        <StyledText {...props} />
        {timestamp && <StyledTimestamp {...props} />}
      </div>
    </article>
  );
}
Component.displayName = "Card.Component";

export function WithTracking(props: CardWithTrackingProps) {
  const uniqueId = useId();
  const tracker = props.trackingId.length ? Tracker.getInstance() : undefined;

  return (
    <div
      id={uniqueId}
      data-component="card"
      data-tracking-id={props.trackingId}
      ref={tracker?.registerComponent}
    >
      <Component {...props} tracker={tracker} />
    </div>
  );
}
WithTracking.displayName = "Card.WithTracking";
